import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to the api url
    const currentUserToken = localStorage.getItem('token')?.slice(1, -1);
    const currentAccessToken = localStorage.getItem('accessToken')?.slice(1, -1);
    //Api for the Expense App
    if (currentUserToken && isAllowedDomain(request.url)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUserToken}`,
        },
      });
    }
    //Api for the MS Graph API
    if (request.url.startsWith(environment.msGraphApi)){
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentAccessToken}`,
        },
      });
    }

    return next.handle(request);
  }
}

// Utility: Check if the hostname matches any "allowedDomains"
function isAllowedDomain(url: string): boolean {
  try {
    const requestHost = new URL(url).host;
    return environment.allowedDomains.some(domain => requestHost === domain);
  } catch {
    // If parsing the URL fails for some reason, return false
    return false;
  }
}
